

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  deletePermission,
  fetchPermissionsCate,
} from "../../features/admin/RoleSlice";
import TableComponent from "../../components/TableComponent";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import PermissionModal from "../../components/admin/PermissionModal";

import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const PermissionCategoty = () => {
  const dispatch = useDispatch();
  const { permissionsCate, status, error } = useSelector(
    (state) => state.roles
  );
  const permissions = useSelector((state) => state.roles?.permissions);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };
  const handleOpenModal = (user = null) => {
    if (user?.id) {
      setCurrentUser(user);
      setIsModalOpen(true);
      // dispatch(fetchRoleById(user.id)).then((res) => {
      //   if (res.meta.requestStatus === "fulfilled") {
      //     setCurrentUser(res.payload);
      //     setIsModalOpen(true);
      //   } else {
      //     toast.error("Không thể lấy dữ liệu phân quyền!");
      //   }
      // });
    } else {
      setCurrentUser(null);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleDelete = () => {
    dispatch(deletePermission(deleteId)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        handleCloseDeleteModal();
        toast.success("Xóa phân quyền thành công!");
      } else {
        toast.error(
          res.payload?.messages || "Đã xảy ra lỗi khi xóa phân quyền!"
        );
      }
    });
  };
  useEffect(() => {
    dispatch(fetchPermissionsCate());
  }, [dispatch, permissions]);
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchPermissionsCate());
    }
  }, [status, dispatch, permissions]);
  if (status === "loading") {
    return <p>Loading...</p>;
  }

  if (status === "failed") {
    return <p>Error: {error}</p>;
  }
  const headers = [{ key: "permissionName", label: "Tên" }];

  if (
    hasPermission("PERMISSIONS_UPDATE") ||
    hasPermission("PERMISSIONS_DELETE") ||
    canViewAuditHistory()
  ) {
    headers.push({ key: "setting", label: "Phương thức" });
  }
  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("PERMISSIONS_UPDATE") && (
          <button
            onClick={() => handleOpenModal(item)}
            className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded "
          >
            <PencilSquareIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("PERMISSIONS_DELETE") && (
          <button
            // onClick={() => handleDelete(item.id)}
            onClick={() => handleOpenDeleteModal(item.id)}
            title="Xóa"
            className=" btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
        <AuditHistoryButton
          module="PERMISSION"
          entityType="Permission"
          entityId={item.id}
        />
      </div>
    ),
  };
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">
        Quản lý phân quyền danh mục
      </h1>
      {hasPermission("PERMISSIONS_CREATE") && (
        <button
          onClick={() => handleOpenModal()}
          className="btn btn-success transition-colors px-4 py-2 rounded mb-4"
        >
          + Thêm phân quyền
        </button>
      )}
      <TableComponent
        headers={headers}
        data={permissionsCate}
        settings={tableSettings}
      />
      {isModalOpen && (
        <PermissionModal
          role={currentUser}
          onClose={handleCloseModal}
          isOpen={isModalOpen}
        />
      )}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default PermissionCategoty;



